const SOURCE = [
    {
        url: 'via.placeholder.com',
    },
    {
        url: 'placekitten.com',
        transform: (url) => url.split('/')[0].split('x').join('/'),
    },
];

const GENERATED = {};

/**
 * Create a placeholder image url
 * @param source
 * @returns {string}
 */
export const createPlaceholder = (source: string) => {
    if (source.startsWith('http')) {
        return source;
    }

    if (!GENERATED[source]) {
        const src = SOURCE[Math.floor(Math.random() * SOURCE.length)];
        GENERATED[source] = `https://${src.url}/${src.transform ? src.transform(source) : source}`;
    }

    return GENERATED[source];
};
